import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import AppLayout from '../../commons/AppLayout/AppLayout';
import Product from './Product';

class ProductRouter extends Component {
  render() {
    const { match } = this.props;

    return (
      <AppLayout footer>
        <Switch>
          <Route path={`${match.path}/id/:productID`}>
            <Product />
          </Route>
          <Route
            path={`${match.path}/:category/:sub_category/:sub_sub_category/:productID`}
          >
            <Product />
          </Route>
          <Redirect to={{ pathname: '/product-not-found' }} />
        </Switch>
      </AppLayout>
    );
  }
}

export default withRouter(ProductRouter);
